<template>
  <div :class="{
    'view-container': true,
    'view-container--mobile': mobile,
  }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ViewContainer',
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .view-container {
    padding-bottom: 20px;
    &--mobile {
      max-width: 370px;
      margin: 0 auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ViewContainer.vue